import GetIcon, { iconMap } from "../../utils/Icon";

const Icons = () => {
  return (
    <div style={{ padding: 20 }}>
      <h2 style={{ marginBottom: 20 }}>All Available Icons</h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(180px, 1fr))", gap: "20px" }}>
        {Object.keys(iconMap).map((name) => (
          <div key={name} style={{ textAlign: "center", border: "1px solid #ccc", padding: 10, borderRadius: 8 }}>
            <GetIcon iconName={name} size={30} color="#00A192" />
            <div style={{ marginTop: 10, fontSize: 12 }}>{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Icons;
